export default "__VITE_ASSET__CbrY1dNc__"